export default "__VITE_ASSET__DwMm3Q9J__"